import { useQuery } from '@tanstack/react-query';
import type { CmsUsefulLinksResponse } from '@gov-nx/api';
import { useAxiosCmsInstance } from '@gov-nx/api';
import { useAppLanguageSelector } from '@gov-nx/core/hooks';
import { useConfiguration } from '@gov-nx/core/service';
import { useCmsUrlPath } from '@gov-nx/store';

export const useCmsUsefulLinksQuery = () => {
	const { cmsKeyCache } = useConfiguration();
	const { language } = useAppLanguageSelector();
	const { axiosCmsInstance } = useAxiosCmsInstance();
	const { baseCmsUrlPath } = useCmsUrlPath();

	const query = useQuery({
		queryFn: async () => {
			const response = await axiosCmsInstance.get<CmsUsefulLinksResponse>(
				`/useful-links/${language}.json?v=${cmsKeyCache}`
			);
			return response.data.data;
		},
		refetchOnWindowFocus: false,
		queryKey: ['cms-useful-links'],
	});

	return {
		data: query.data ?? [],
		isLoading: query.isLoading,
		baseCmsUrlPath,
	};
};
